import axiosInstance from './axiosInstance';

export interface IManifestCountry {
  name: string;
  phone: {
    value: string;
    label: string;
    code: number;
  };
}

export interface IManifestResponse {
  timezones: string[];
  languages: Record<string, string>;
  countries: IManifestCountry[];
}

class ManifestService {
  private static instance: ManifestService;
  private manifestCache: IManifestResponse | null = null;

  private constructor() {}

  public static getInstance(): ManifestService {
    if (!ManifestService.instance) {
      ManifestService.instance = new ManifestService();
    }
    return ManifestService.instance;
  }

  public async getManifest(forceRefresh: boolean = false): Promise<IManifestResponse> {
    if (!forceRefresh && this.manifestCache) {
      return this.manifestCache;
    }

    try {
      const response = await axiosInstance.get<IManifestResponse>('/manifest');
      this.manifestCache = response.data;
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch manifest');
    }
  }

  public async getCountries(forceRefresh: boolean = false): Promise<IManifestCountry[]> {
    const manifest = await this.getManifest(forceRefresh);
    return manifest.countries || [];
  }

  public async getLanguages(forceRefresh: boolean = false): Promise<Record<string, string>> {
    const manifest = await this.getManifest(forceRefresh);
    return manifest.languages || {};
  }
}

export default ManifestService.getInstance();
